class ProductTile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleVariantSwatchClick.bind(this));
    this.addEventListener('keydown', this.handleVariantSwatchKeydown.bind(this));

    if (document.readyState === 'complete') {
      this.iniFeaturesSlider();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.iniFeaturesSlider();
      });
    }
  }

  handleVariantSwatchClick(e) {
    const variantSwatch = e.target.closest('[data-variant-swatch]');
    if (!variantSwatch) return;

    const {
      variantId,
      variantImage,
      variantComparePrice,
      variantPrice,
    } = variantSwatch.dataset;

    this.updateProductDetails(variantImage, variantComparePrice, variantPrice);
    this.updateVariantSelection(variantSwatch);
    this.updateAtcInput(variantId, variantSwatch.disabled);
  }

  handleVariantSwatchKeydown(e) {
    const variantSwatch = e.target.closest('[data-variant-swatch]');
    if (!variantSwatch) return;
  
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.handleVariantSwatchClick(e);
    }
  }

  iniFeaturesSlider() {
    const sliderWrappers = document.querySelectorAll('[data-features-slider-wrapper]');

    sliderWrappers.forEach((sliderWrapper) => {
      const flkty = new Flickity( sliderWrapper, {
        accessibility: true,
        cellAlign: "left",
        cellSelector: '[data-feature-slide]',
        pageDots: false,
        prevNextButtons: true,
        contain: true,
      });
    });
  }

  updateProductDetails(variantImage, variantComparePrice, variantPrice) {
    const featuredImageEl = this.querySelector('[data-product-image]');
    if (featuredImageEl && !featuredImageEl.disabled) {
      featuredImageEl.src = variantImage;
      featuredImageEl.srcset = '';
    }

    const compareAtPriceEl = this.querySelector('[data-compare-at-price]');
    if (compareAtPriceEl) {
      if (variantComparePrice != 'false') {
        compareAtPriceEl.classList.remove('hidden');
        compareAtPriceEl.textContent = variantComparePrice;
      } else {
        compareAtPriceEl.classList.add('hidden');
        compareAtPriceEl.textContent = '';
      }
    }

    const variantPriceEl = this.querySelector('[data-price]');
    if (variantPriceEl) {
      if (variantPrice != 'false') {
        variantPriceEl.classList.remove('hidden');
        variantPriceEl.textContent = variantPrice;
      } else {
        variantPriceEl.classList.add('hidden');
        variantPriceEl.textContent = '';
      }
    }
  }

  updateVariantSelection(variantSwatch) {
    this.querySelectorAll('[data-variant-swatch]').forEach((el) => {
      if (el.isSameNode(variantSwatch)) {
        el.classList.add('selected');
        return;
      }
      el.classList.remove('selected');
    });
  }

  updateAtcInput(variantId, isDisabled) {
    if (isDisabled) return;

    const atcInputEl = this.querySelector('[data-atc-input]');
    if (atcInputEl) {
      atcInputEl.value = variantId;
    }
  }
}

customElements.define('product-tile', ProductTile);
